<template>
    <div class="container vertical-align login">
      <v-dialog/>
      <div class="row">
        <div class="col-md-5">
          <form class="form-signin">
            <svg id="logo" class="fm-logo" data-name="logo-conexa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135.25 25.15">
              <title>Conexa - </title>
              <path class="conexa" d="M24.86,26.15a8.09,8.09,0,0,1-8.19-8,8.19,8.19,0,0,1,16.38,0,8.09,8.09,0,0,1-8.19,8Zm0-12.59a4.62,4.62,0,1,0,4.75,4.62,4.69,4.69,0,0,0-4.75-4.62ZM8.19,26.15a8.1,8.1,0,0,1-8.19-8,8.09,8.09,0,0,1,8.19-8,8.26,8.26,0,0,1,6.37,2.95,1.63,1.63,0,0,1-.25,2.35,1.74,1.74,0,0,1-2.42-.24A4.79,4.79,0,0,0,8.2,13.56a4.62,4.62,0,1,0,0,9.24,4.83,4.83,0,0,0,3.7-1.71,1.76,1.76,0,0,1,2.42-.25,1.65,1.65,0,0,1,.25,2.36A8.29,8.29,0,0,1,8.19,26.15ZM43,10.21a8.09,8.09,0,0,0-8.19,8v6.29a1.72,1.72,0,0,0,3.44,0V18.18a4.75,4.75,0,0,1,9.5,0v6.29a1.73,1.73,0,0,0,3.45,0V18.18a8.09,8.09,0,0,0-8.2-8Zm57.88,0a1.71,1.71,0,0,0-1.72,1.49,8.19,8.19,0,0,0-4.76-1.49,8.09,8.09,0,0,0-8.19,8,8.09,8.09,0,0,0,8.19,8,8.33,8.33,0,0,0,4.76-1.49,1.72,1.72,0,0,0,1.72,1.49,1.7,1.7,0,0,0,1.72-1.68V11.88A1.7,1.7,0,0,0,100.85,10.21ZM94.37,22.8a4.62,4.62,0,1,1,4.75-4.62,4.7,4.7,0,0,1-4.75,4.62ZM79.91,18.18,84.09,13a1.65,1.65,0,0,0-.24-2.31l0,0a1.76,1.76,0,0,0-2.42.28l-3.65,4.55-3.66-4.55a1.74,1.74,0,0,0-2.41-.28,1.64,1.64,0,0,0-.34,2.3.1.1,0,0,1,0,.05l4.18,5.2-4.18,5.2a1.64,1.64,0,0,0,.25,2.31l0,0a1.73,1.73,0,0,0,1.06.35,1.75,1.75,0,0,0,1.36-.64l3.65-4.54,3.65,4.54a1.77,1.77,0,0,0,2.42.29,1.64,1.64,0,0,0,.29-2.35Zm-18.83-8a8.09,8.09,0,0,0-8.19,8,8.09,8.09,0,0,0,8.19,8h4.1a1.68,1.68,0,1,0,0-3.35h-4.1a4.78,4.78,0,0,1-4.43-2.95h10.9a1.7,1.7,0,0,0,1.72-1.67,8.09,8.09,0,0,0-8.19-8ZM56.65,16.5a4.81,4.81,0,0,1,8.86,0Zm57.16,8.63h0a.43.43,0,0,0,0-.05v0a4.48,4.48,0,0,0-3.27-3.2h-.07a.64.64,0,0,0-.2,0,.86.86,0,0,0-.86.84h0v1.81a1.7,1.7,0,0,0,1.72,1.67H113a.84.84,0,0,0,.86-.83A.55.55,0,0,0,113.81,25.13Z" transform="translate(0 -1)"/>
              <path class="cruz" d="M133.53,8.55h-6V2.67A1.7,1.7,0,0,0,125.76,1h-6.88a1.71,1.71,0,0,0-1.73,1.67V8.55h-6a1.7,1.7,0,0,0-1.72,1.68v2.58a.85.85,0,0,0,.8.83h0a12.72,12.72,0,0,1,12.06,11.72h0a.86.86,0,0,0,.86.79h2.65a1.7,1.7,0,0,0,1.72-1.68V18.6h6a1.7,1.7,0,0,0,1.72-1.68v-6.7A1.7,1.7,0,0,0,133.53,8.55Z" transform="translate(0 -1)"/>
              <path class="conexa" d="M119.46,25.22h0a10,10,0,0,0-9.1-8.86h-.06a.86.86,0,0,0-.91.79v1.07a.86.86,0,0,0,.77.84h0a7.26,7.26,0,0,1,6.53,6.33.86.86,0,0,0,.86.77h1a.85.85,0,0,0,.86-.84Z" transform="translate(0 -1)"/>
            </svg>
            <p class="h3 font-weight-normal">Para acessar o atendimento, informe o código de acesso rápido, que foi fornecido a você.</p>
            <div class="relative">
              <input type="text" class="form-control" placeholder="Código de Acesso" maxlength="10" required="true" v-model="codigoAcesso">
              <svg id="niver" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z"/>
                        <path stroke="#3CB4E7" stroke-width="2" d="M12.64 4.383a5.997 5.997 0 0 1 1.58 5.693l6.765 6.765-1.21 2.39-3.295.187a1 1 0 0 1-1.01-1.303l.092-.288a.711.711 0 0 0-.968-.865.61.61 0 0 1-.807-.803l.02-.044a.523.523 0 0 0-.731-.67l-.7.383a1 1 0 0 1-1.188-.17L9.95 14.423a6 6 0 1 1 2.69-10.04zM9.105 6.504a2 2 0 1 0-2.829 2.829 2 2 0 0 0 2.829-2.829z"/>
                    </g>
                </svg>
            </div>
            <button class="btn btn-lg btn-primary btn-block button success" type="button" @click="acessar">Acessar</button>
          </form>
        </div>
        <div class="col-md-7">
          <img src="@/assets/img/conexa.vc.svg" alt="" class="img-fluid float-right medico">
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'logon',
  props:['codigo'],
  created(){
    sessionStorage.clear()
    if(this.codigo != null){
      this.codigoAcesso = this.codigo
      this.acessar()
    }
    //valida https (caso o cliente não esteja em HTTP faz o redirect para HTTPS.)
    if(location.href.indexOf("localhost") < 0 && location.href.indexOf("https") < 0){
        location.href = location.href.replace("http","https")
    }
  },
  data() {
    return {
        codigoAcesso : null,
        isMobile: (/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))
    }
  },
  methods : {
    acessar(){
        this.$conexaApi.get('/integration/app-paciente/usuario/login/codigo-acesso/'+this.codigoAcesso.toUpperCase())
        .then((response) => {
            sessionStorage.setItem("usuario-nome", response.data.object.usuario.nome)
            sessionStorage.setItem("usuario-token", response.data.object.token)
            sessionStorage.setItem("usuario-clinica", response.data.object.usuario.clinica.id)
            if(this.isMobile){
               location.href = '/aplicativo'
            }else{
               location.href = '/sala-espera'
            }
        }) .catch((error) => {
            this.$notify({
                duration: 4000,
                group: 'mensagens',
                type: 'error', 
                title: 'Mensagem',
                text: error.response.data.msg
            })
        }).finally(() => {
            NProgress.done()
        })   
    }
  }
}
</script>